import React from "react";

import { SetupSection } from "./components/setup-section";
import { type PlatformDetails } from "./platform-details";

export function AmazonAds({
  connectionContent,
}: {
  connectionContent: React.ReactNode;
}) {
  return (
    <SetupSection title="Log into Amazon Ads to connect integration">
      {connectionContent}
    </SetupSection>
  );
}

export const AmazonAdsDetails: PlatformDetails = {
  northbeamDocUrl: "https://docs.northbeam.io/docs/tracking-for-amazon",
  officialDocUrl: "",
  additionalDetails: [
    {
      title: "What does the Amazon Ads Integration track?",
      content: `Northbeam natively integrates with the Amazon Ads API.
        By doing so, we pull all your PPC spend from your Amazon Marketplaces.`,
    },
    {
      title: "Why do I need to connect Amazon Ads?",
      content: "Amazon Ads fetches your store's spend.",
    },
    {
      title: "Is there an integration with Amazon DSP or Vendor Central?",
      content: (
        <>
          We do not support Amazon DSP or Vendor Central at this time. If you'd
          like to upload costs from Amazon DSP, feel free to use a{" "}
          <a href="#">Custom Spendsheet</a>.
        </>
      ),
    },
  ],
};
